import React from 'react';
import MainRouter from './router/MainRouter';
import './App.css';

function App() {
  return <MainRouter />;
}

export default App;
